import * as React from "react";
import { Typography, Grid, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import "./lotterySystem.css";
import GetInTouchForm from './GetInTouchForm';
import ourLocation from '../common/gif/ourLocation.gif';
import callUs from '../common/gif/callUs.gif';
import emailUs from '../common/gif/emailUs.gif';

const ContactUs: React.FC = () => {
  const { t } = useTranslation('translation');
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Grid>
      <Typography className="landing-section-heading landing-secondary-color landing-headers-orange-color" variant="h6" align="center">{t("getInTouchToday")}</Typography>
      <Grid container spacing={2} mt={4} direction={isMobileOrTablet ? 'column' : 'row'}>
        <Grid className="landing-grid-form" item xs={12} md={6}>
          <GetInTouchForm />
        </Grid>
        <Grid className="landing-grid-contact-details-list" item xs={12} md={6} alignItems="center">
          <Typography className="landing-grid-contact-details" variant="h6" align="center">{t("contactDetails")}</Typography>
          <Grid item xs={12} display="flex" mt={3}>
            <img className="landing-location-img" src={ourLocation} alt="our location gif" />
            <Grid className="landing-grid-contact-details-list-item" mt={2}>
              <Typography className="landing-grid-contact-details-list-item-title">{t("ourLocation")}</Typography>
              <Typography className="landing-grid-contact-details-list-item-value location-value">{t("ourLocationValue")}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} display="flex" mt={3}>
            <img className="landing-call-img" src={callUs} alt="call us gif" />
            <Grid className="landing-grid-contact-details-list-item" mt={2}>
              <Typography className="landing-grid-contact-details-list-item-title">{t("callUs")}</Typography>
              <Typography className="landing-grid-contact-details-list-item-value"><a href="tel:+18333141825">{t("callUsValue")}</a></Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} display="flex" mt={3}>
            <img className="landing-email-img" src={emailUs} alt="email us gif" />
            <Grid className="landing-grid-contact-details-list-item" mt={1}>
              <Typography className="landing-grid-contact-details-list-item-title">{t("emailUs")}</Typography>
              <Typography className="landing-grid-contact-details-list-item-value"><a href={`mailto:${t("emailUsValue")}`}>{t("emailUsValue")}</a></Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      </Grid>
    </>
  )
}

export default ContactUs;